// extracted by mini-css-extract-plugin
export default {"button":"Filters_button__QqOpP","tag-button":"Filters_tag-button__nj1cH"};